import heroBg from '../../../assets/img/Autumn_season.png';
import { BRAND, CampaignLogo } from './KhareefBrand';

/**
 * Preview of the portal hero (app-khareef-hero).
 *
 * Mirrors the public page rather than the CMS chrome, so the copy is Arabic and
 * RTL regardless of the language the CMS is switched to - the point of this
 * section is to show admins what a visitor actually sees.
 */
export default function KhareefHero({ compact = false }) {
  return (
    <div className="relative overflow-hidden" dir="rtl" style={{ backgroundColor: BRAND.teal }}>
      {/* object-contain, not cover: the asset is campaign artwork rather than a
          photo, so cropping or filling it distorts the lockup. The teal card
          behind it absorbs the letterboxing. */}
      <img
        src={heroBg}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-contain object-center"
      />

      {/* Scrim, heaviest on the text side (right in RTL) so white copy keeps
          contrast over the light areas of the artwork. */}
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(to left, ${BRAND.tealSolid} 0%, ${BRAND.tealSolid} 30%, ${BRAND.teal72} 55%, ${BRAND.teal25} 100%)`,
        }}
      />

      <div
        className={`relative flex items-center ${compact ? 'py-10' : 'py-16 md:py-24'}`}
        style={{ minHeight: compact ? 260 : 380 }}
      >
        {/* justify-start inside dir="rtl" resolves to the right edge, which is
            where the scrim is heaviest and where the portal puts the lockup. */}
        <div className="w-full px-6 md:px-10 flex justify-start">
          <div className="text-right text-white max-w-xl">
            <CampaignLogo size={compact ? 'md' : 'lg'} />
          </div>
        </div>
      </div>

      {/* Purple strip beneath the hero, as on the portal */}
      <div
        className="relative py-3 px-6 text-white text-sm text-right"
        style={{ backgroundColor: BRAND.purple, letterSpacing: '0.3px' }}
        dir="rtl"
      >
        شاركنا صورتك من خريف ظفار
      </div>
    </div>
  );
}
